module.exports = __webpack_public_path__ + "static/img/placholder_512.a36a1256.svg";